import {
  HTTP
} from "../../../http-common";
import {
  getField,
  updateField
} from "vuex-map-fields";
import {
  httpError
} from "../../../models/httpError";
import {
  Uploads
} from "../../../models/Uploads";

const state = {
  rows: [],
  message: new httpError(),
  session: null
};

//getters

const getters = {
  getField
};

//Mutations
const mutations = {
  addRow(state) {
    state.rows.push(new Uploads());
  },
  clearRows(state) {
    if (typeof state.rows !== "object") state.rows = [];
    state.rows.length = 0;
    state.rows.push(new Uploads());
  },
  removeRow(state) {
    state.rows.pop();
  },

  setProgress(state, message) {
    state.message = message;
  },
  setRows(state, upload) {
    state.rows = upload;
  },
  setSession(state, session) {
    state.session = session;
  },
  updateField
};

//ACTIONS
const actions = {
  reset({
    commit
  }) {
    commit("clearRows");
  },
  populateUploads({
    commit,
    dispatch,
    rootState
  }, orderID) {
    return new Promise((resolve, reject) => {
      let url = null;
      url = "GetFilesOnOrder/" + orderID;

      var response = HTTP.get("Order/" + url);
      response
        .then(function (data) {
          if (data.status === 200) {
            commit("setRows", data.data);
          } else commit("setRows", []);
          dispatch(
            "setMessage",
            new httpError({
              message: "Retrieved OK",
              httpStatus: 200
            })
          );
          resolve(data.data);
        })
        .catch(function (err) {
          commit("setRows", []);
          dispatch(
            "setMessage",
            new httpError({
              message: "Error: " + err.message,
              httpStatus: 500
            })
          );

          reject(err);
        });
    });
  },
  addUpload() {},
  updateUploadsOnOrder({
    commit,
    dispatch,
    rootState
  }, form) {
    return new Promise((resolve, reject) => {
      let url = "";

      if (form.guid == null || form.guid == "undefined") {
        if (
          rootState.orders.rows[0].orderStatus == 1 &&
          rootState.orders.rows[0].orderGUID !== null
        ) {
          url = `UploadFilesByGuid/${rootState.orders.rows[0].orderGUID}/${form.fileType}`;
        } else {
          url = `UploadFiles/${rootState.orders.rows[0].orderID}/${form.fileType}`;
        }
      } else {
        if (
          form.guid !== null ||
          form.guid !== "00000000-0000-0000-0000-000000000000"
        )
          url = "UploadFilesByGuid/" + form.guid;
      }

      var response = HTTP.post("order/" + url, form.data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      response
        .then(data => {
          if (data.status == 200) {
            commit("setRows", data.data);
            commit("setSession", data.data.session);
            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },

  async removeRows({
    state,
    commit
  }, newVal) {
    //rowCount is the number of rows to finish with
    var oldVal = 0 || state.rows.length;
    var rows = [];
    for (var i = oldVal; i > newVal; i--) {
      rows.push(state.rows[i - 1]);
      commit("removeRow");
    }
    //try {
    //    var ipexts = await HTTP.delete('order/DeleteIPExtsFromOrder/' + rootState.orders.rows[0].orderID, { data: rows });
    //    return Promise.resolve(ipexts);

    //} catch (e) {
    //    return Promise.reject(err);
    //}
    return Promise.resolve();
  },
  setMessage({
    commit
  }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  },
  getAttachment({
    dispatch,
    rootState
  }, attachment) {
    return new Promise(reject => {
      let url;
      if (
        attachment.orderID == 0 ||
        attachment.orderID == "undefined" ||
        attachment.orderID == null
      )
        url = "order/getAttachment/" + rootState.orders.rows[0].orderID;
      else url = "order/getAttachment/" + attachment.orderID;

      var response = HTTP.post(
        url, {
          filename: attachment.file.filename
        }, {
          responseType: "blob"
        }
      );
      response
        .then(data => {
          const url = window.URL.createObjectURL(
            new Blob([data.data], {
              type: attachment.file.contentType
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", attachment.file.filename);
          document.body.appendChild(link);
          link.click();
        })

        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
  getExtension(fileName) {
    return fileName.substr(fileName.lastIndexOf(".") + 1, fileName.length - 1);
  },
  deleteAttachment({
    rootState,
    dispatch,
    commit
  }, file) {
    return new Promise((resolve, reject) => {
      try {
        let url;
        if (
          file.orderID == 0 ||
          file.orderID == "undefined" ||
          file.orderID == null
        ) {
          url = "order/RemoveAttachment/" + rootState.orders.rows[0].orderID;
          HTTP.delete(url, {
            data: {
              fileGuid: file.guid
            }
          }).then(response => {
            if (response.status == 200) {
              dispatch("populateUploads", rootState.orders.rows[0].orderGuid);
              resolve();
            }
          });
        } else {
          url = "order/RemoveAttachment/" + file.orderID;

          HTTP.delete(url, {
            data: {
              fileGuid: file.guid
            }
          }).then(customerResponse => {
            if (customerResponse.status == 200) {
              resolve(customerResponse.data);
            }
          });
        }
      } catch (error) {
        dispatch(
          "setMessage",
          new httpError({
            message: "Attachment not removed: " + error.message,
            httpStatus: 500
          })
        );
        reject(error);
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};